// extracted by mini-css-extract-plugin
export default {"tab":"Tabs--tab--5HleF","tab-selected":"Tabs--tab-selected--sHh7j","tabSelected":"Tabs--tab-selected--sHh7j"};